const STORAGE_PREFIX = "listState:";

export function getListState(listKey) {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${listKey}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveListState(listKey, state) {
  try {
    const existing = getListState(listKey) || {};
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${listKey}`,
      JSON.stringify({ ...existing, ...state }),
    );
  } catch {
    // ignore storage errors
  }
}

export function clearListState(listKey) {
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${listKey}`);
  } catch {
    // ignore storage errors
  }
}
